import _ from 'underscore';
import { buildSortingConversions } from '@bingads-webui-campaign/column-conversions';
import { Decorator } from './decorator';

export class SortingDecorator extends Decorator {
  /**
   * Creates an instance of SortingDecorator.
   * @param {Object} {
   * featureName: Name of feature, such as "PerformanceGrid",
   * deps: The legacy dependencies of the decorator:
   * deps.fetchSortInfo: from 'component/bingads-grid/service/fetch-sortinfo',
   * ignoreColumns: columns to ignore for order by when transforming the query params
   * @memberof SortingDecorator
   */
  constructor({
    featureName, deps, ignoreColumns,
    IsColumnConversionEnabled = false, columnConversions,
  }) {
    super({ name: 'sorting', deps, expectedDeps: ['fetchSortInfo'] });

    this.featureName = featureName;
    this.fetchSortInfo = deps.fetchSortInfo;
    this.ignoreColumns = ignoreColumns;
    this.IsColumnConversionEnabled = IsColumnConversionEnabled;
    if (IsColumnConversionEnabled) {
      ({
        applySortingInfoConversion: this.applySortingInfoConversion,
      } = buildSortingConversions(columnConversions));
    }
  }

  getValueAsync() {
    return this.fetchSortInfo(this.featureName);
  }

  buildQuery(queryParams, { orderbyInfo, sortableHeader }) {
    const transformedQueryParams = _.extend({}, queryParams);

    if (this.IsColumnConversionEnabled) {
      const { orderbyInfo: patchedOrderbyInfo } =
        this.applySortingInfoConversion({ sortableHeader, orderbyInfo });

      if (patchedOrderbyInfo && patchedOrderbyInfo.length > 0) {
        transformedQueryParams.orderby = this.ignoreColumns ?
          _.reject(patchedOrderbyInfo, ({ key }) => _.contains(this.ignoreColumns, key)) :
          patchedOrderbyInfo;
      }
    } else if (orderbyInfo && orderbyInfo.length > 0) {
      transformedQueryParams.orderby = this.ignoreColumns ?
        _.reject(orderbyInfo, ({ key }) => _.contains(this.ignoreColumns, key)) :
        orderbyInfo;
    }
    return transformedQueryParams;
  }
}
